/*

  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

*/
(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;
	var shippingEstimateStrings = {};

	var loadPdpFreeShippingConfig = function () {
		var el = document.getElementById('pdp-free-shipping-config');
		if (!el || !el.textContent) return null;
		try {
			var o = JSON.parse(el.textContent);
			if (!o || !o.enabled) return null;
			var prefix = o.prefix != null ? String(o.prefix).trim() : '';
			if (!prefix.length) return null;
			var amount = o.amount != null ? String(o.amount).trim() : '';
			return { prefix: prefix, amount: amount };
		} catch (e) {
			return null;
		}
	};

	var loadShippingCalcAssets = function () {
		var el = document.getElementById('shipping-calc-assets');
		if (!el || !el.textContent) return {};
		try {
			var o = JSON.parse(el.textContent);
			return o && typeof o === 'object' ? o : {};
		} catch (e) {
			return {};
		}
	};

	var loadShippingEstimateStrings = function () {
		var defaults = {
			label_cta: 'clique e confira',
			label_suffix: ' o prazo de entrega',
			zip_placeholder: 'Digite seu CEP',
			unknown_zip_link: 'não sei meu frete',
			calculate: 'Calcular',
			calculating: 'Calculando...',
			invalid_cep_html: '<p>CEP inválido ou não encontrado. Por favor, verifique o CEP digitado.</p>',
			rate_for: 'por',
			price_currency: 'R$',
			local_delivery: 'Entrega local',
			one_business_day: '1 dia útil',
			business_days: '{{ count }} dias úteis'
		};
		var el = document.getElementById('product-shipping-estimate-i18n');
		var parsed = {};
		if (el && el.textContent) {
			try {
				parsed = JSON.parse(el.textContent);
			} catch (e) {
				parsed = {};
			}
		}
		var out = {};
		for (var key in defaults) {
			if (defaults.hasOwnProperty(key)) {
				var v = parsed[key];
				out[key] = v != null && String(v).length ? v : defaults[key];
			}
		}
		return out;
	};

	var formatBusinessDays = function (template, count) {
		return String(template).replace(/\{\{\s*count\s*\}\}/g, String(count));
	};

  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }

	/* create a message box */
	var shippingMessage = document.createElement('p');
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
	var currentProvince = '';
	var CEP_DIGIT_COUNT = 8;
	var CEP_DISPLAY_MAX_LENGTH = 9;

	var cepDigitsOnly = function (value) {
		return String(value == null ? '' : value).replace(/\D/g, '').slice(0, CEP_DIGIT_COUNT);
	};

	var normalizeCepInput = function (input) {
		if (!input) return '';
		var raw = String(input.value || '');
		var digits = cepDigitsOnly(raw);
		var display;
		if (digits.length <= 5) {
			display = digits;
			/* Allow a lone "-" after 5 digits so typing "01310-" does not jump the search */
			if (raw.indexOf('-') !== -1 && digits.length === 5) {
				display = digits + '-';
			}
		} else {
			display = digits.slice(0, 5) + '-' + digits.slice(5);
		}
		if (input.value !== display) {
			input.value = display;
		}
		return digits;
	};

	var cepRanges = {
		'Acre': [{ start: 69900000, end: 69999999 }],
		'Alagoas': [{ start: 57000000, end: 57999999 }],
		'Amapá': [{ start: 68900000, end: 68999999 }],
		'Amazonas': [
			{ start: 69000000, end: 69299999 },
			{ start: 69400000, end: 69899999 }
		],
		'Bahia': [{ start: 40000000, end: 48999999 }],
		'Ceará': [{ start: 60000000, end: 63999999 }],
		'Distrito Federal': [
			{ start: 70000000, end: 72799999 },
			{ start: 73000000, end: 73699999 }
		],
		'Espírito Santo': [{ start: 29000000, end: 29999999 }],
		'Goiás': [
			{ start: 72800000, end: 72999999 },
			{ start: 73700000, end: 76799999 }
		],
		'Maranhão': [{ start: 65000000, end: 65999999 }],
		'Mato Grosso': [{ start: 78000000, end: 78899999 }],
		'Mato Grosso do Sul': [{ start: 79000000, end: 79999999 }],
		'Minas Gerais': [{ start: 30000000, end: 39999999 }],
		'Pará': [{ start: 66000000, end: 68899999 }],
		'Paraíba': [{ start: 58000000, end: 58999999 }],
		'Paraná': [{ start: 80000000, end: 87999999 }],
		'Pernambuco': [{ start: 50000000, end: 56999999 }],
		'Piauí': [{ start: 64000000, end: 64999999 }],
		'Rio de Janeiro': [{ start: 20000000, end: 28999999 }],
		'Rio Grande do Norte': [{ start: 59000000, end: 59999999 }],
		'Rio Grande do Sul': [{ start: 90000000, end: 99999999 }],
		'Rondônia': [{ start: 76800000, end: 76999999 }],
		'Roraima': [{ start: 69300000, end: 69399999 }],
		'Santa Catarina': [{ start: 88000000, end: 89999999 }],
		'São Paulo': [{ start: parseInt('01000000', 10), end: 19999999 }],
		'Sergipe': [{ start: 49000000, end: 49999999 }],
		'Tocantins': [{ start: 77000000, end: 77999999 }]
	};

	var buscarEstadoPorCEP = function(cep) {
		cep = cep.replace(/\D/g, '');
		
		if (cep.length !== 8) {
			currentProvince = '';
			return '';
		}

		var cepNumero = parseInt(cep, 10);

		for (var estado in cepRanges) {
			if (cepRanges.hasOwnProperty(estado)) {
				var ranges = cepRanges[estado];
				for (var i = 0; i < ranges.length; i++) {
					if (cepNumero >= ranges[i].start && cepNumero <= ranges[i].end) {
						currentProvince = estado;
						log('Estado encontrado: ' + estado + ' (CEP: ' + cep + ')');
						return estado;
					}
				}
			}
		}

		currentProvince = '';
		log('CEP não encontrado em nenhum range: ' + cep);
		return '';
	};

	var injectShippingCalcDisclosureStyles = function () {
		if (document.getElementById('shipping-calc-disclosure-styles')) return;
		var st = document.createElement('style');
		st.id = 'shipping-calc-disclosure-styles';
		st.textContent =
			'.shopping-calculator .shipping-calc-disclosure{margin:0;font-family:Arial,Helvetica,sans-serif}' +
			'.shopping-calculator .shipping-calc-disclosure__summary{display:flex;flex-direction:column;align-items:stretch;width:100%;padding:0;border-bottom:none;cursor:pointer;list-style:none;box-sizing:border-box}' +
			'.shopping-calculator .shipping-calc-disclosure__summary-top{display:flex;align-items:center;justify-content:space-between;width:100%;padding:15px 0;border-bottom:1px solid #e0e0e0;box-sizing:border-box}' +
			'.shopping-calculator .shipping-calc-disclosure__summary::-webkit-details-marker{display:none}' +
			'.shopping-calculator .shipping-calc-disclosure__left{display:flex;align-items:center;gap:10px;min-width:0}' +
			'.shopping-calculator .shipping-calc-disclosure__icon{display:flex;flex-shrink:0;line-height:0}' +
			'.shopping-calculator .shipping-calc-disclosure__icon svg,.shopping-calculator .shipping-calc-disclosure__icon img{display:block;width:30px;height:30px;}' +
			'.shopping-calculator .shipping-calc-disclosure__label{text-align:left;color:inherit;font-family:Roobert;font-size:16px;font-style:normal;font-weight:400;line-height:113%;}' +
			'.shopping-calculator .shipping-calc-disclosure__label-cta{text-decoration:underline;color:inherit;font-family:Roobert;font-size:16px;font-style:normal;font-weight:600;line-height:113%;text-decoration-line:underline;text-decoration-style:solid;text-decoration-skip-ink:none;text-decoration-thickness:auto;text-underline-offset:auto;text-underline-position:from-font;}' +
			'.shopping-calculator .shipping-calc-disclosure__chevron{display:flex;flex-shrink:0;color:#757575;line-height:0;transition:transform .2s ease}' +
			'.shopping-calculator .shipping-calc-disclosure__chevron svg{display:block}' +
			'.shopping-calculator details[open].shipping-calc-disclosure .shipping-calc-disclosure__chevron{transform:rotate(180deg)}' +
			'.shopping-calculator .shipping-calc-disclosure__content{padding-top:14px}' +
			'.shopping-calculator .shipping-calc-disclosure__row{display:flex;align-items:stretch;flex-direction:row;gap:4px;width:100%;box-sizing:border-box}' +
			'.shopping-calculator .shipping-calc-disclosure__input{flex:1 1 auto;min-width:0;box-sizing:border-box;height:50px;margin:0;border:1px solid #d8d8d8;border-radius:0;background:#fff;padding:0 12px;font-size:14px;line-height:1.2;color:#444;font-family:inherit}' +
			'.shopping-calculator .shipping-calc-disclosure__input::placeholder{color:#999}' +
			'.shopping-calculator .shipping-calc-disclosure__input:focus{outline:2px solid rgba(151,16,82,.25);outline-offset:0;border-color:#971052}' +
			'.shopping-calculator .shipping-calc-disclosure__submit{flex:0 0 auto;box-sizing:border-box;height:50px;margin:0;padding:0 18px;border:none;border-radius:0;background:#971052;font-family:inherit;cursor:pointer;white-space:nowrap;color:#FFF;font-size:12px;font-style:normal;font-weight:700;line-height:24px;letter-spacing:-0.12px;text-transform:uppercase;}' +
			'.shopping-calculator .shipping-calc-disclosure__submit:hover{background:#7d0d45}' +
			'.shopping-calculator .shipping-calc-disclosure__submit.disabled{opacity:.75;cursor:not-allowed}' +
			'.shopping-calculator .shipping-calc-disclosure__cep-link{display:inline-block;margin-top:12px;text-decoration:underline;font-family:Roobert;font-size:14px;font-style:normal;font-weight:400;line-height:18px;text-decoration-line:underline;text-decoration-style:solid;text-decoration-skip-ink:none;text-decoration-thickness:auto;text-underline-offset:auto;text-underline-position:from-font;color:inherit;}'+
			'.shopping-calculator .shipping-calc-disclosure__cep-link:hover{color:#444}' +
			'.shopping-calculator .shipping-calc-disclosure__content > p{margin:12px 0 0;font-size:14px;line-height:1.4;color:#444;text-align:left}' +
			'.shopping-calculator .shipping-calc-disclosure__rates{list-style:none;margin:12px 0 0;padding:0;text-align:left}' +
			'.shopping-calculator .shipping-calc-disclosure__rates-item{margin:0 0 14px;padding:0;padding-left:0;list-style:none;text-align:left;font-size:14px;line-height:1.45;color:#444}' +
			'.shopping-calculator .shipping-calc-disclosure__rates-item:last-child{margin-bottom:0}' +
			'.shopping-calculator .shipping-calc-disclosure__rates-item b{font-weight:700}' +
			'.shopping-calculator .shipping-calc-disclosure__rates-days{display:block;margin-top:2px;font-weight:400}' +
			'.shopping-calculator .shipping-calc-disclosure__pdp-free-shipping{margin:0;padding:12px 0 0;text-align:center;font-family:Roobert;font-size:14px;font-style:normal;font-weight:400;line-height:1.4;color:#757575}' +
			'.shopping-calculator .shipping-calc-disclosure__pdp-free-shipping strong{font-weight:700;color:#757575}';
		document.head.appendChild(st);
	};

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		shippingEstimateStrings = loadShippingEstimateStrings();
		injectShippingCalcDisclosureStyles();

		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* create the province state picker */
		shippingProvince.name = 'shipping_address[province]';

		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
		shippingZip.value = '';
		shippingZip.setAttribute('inputmode', 'numeric');
		shippingZip.setAttribute('maxlength', String(CEP_DISPLAY_MAX_LENGTH));
		shippingZip.setAttribute('autocomplete', 'postal-code');
		shippingZip.placeholder = shippingEstimateStrings.zip_placeholder;
		
		shippingZip.addEventListener('blur', function() {
			var cepLimpo = normalizeCepInput(shippingZip);
			if (cepLimpo.length > 0) {
				buscarEstadoPorCEP(cepLimpo);
			}
		});
		
		var cepTimeout;
		shippingZip.addEventListener('input', function() {
			normalizeCepInput(shippingZip);
			clearTimeout(cepTimeout);
			cepTimeout = setTimeout(function() {
				var limpo = normalizeCepInput(shippingZip);
				if (limpo.length === CEP_DIGIT_COUNT) {
					buscarEstadoPorCEP(limpo);
				}
			}, 500);
		});

		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';

		/* create a link if don't know the Zip code */
		var shippingCalcUnknownZip = document.createElement('a');
		shippingCalcUnknownZip.className = 'link';
		shippingCalcUnknownZip.setAttribute('href', 'https://buscacepinter.correios.com.br/app/endereco/index.php');
		shippingCalcUnknownZip.setAttribute('target', '_blank');
		shippingCalcUnknownZip.innerText = shippingEstimateStrings.unknown_zip_link;
		shippingCalcUnknownZip.className = 'shipping-calc-disclosure__cep-link';

		var shippingCalcAssets = loadShippingCalcAssets();
		var truckIconUrl =
			shippingCalcAssets.icon_truck_delivery != null
				? String(shippingCalcAssets.icon_truck_delivery).trim()
				: '';

		var shippingCalcIcon = document.createElement('span');
		shippingCalcIcon.className = 'shipping-calc-disclosure__icon';
		if (truckIconUrl) {
			var truckImg = document.createElement('img');
			truckImg.src = truckIconUrl;
			truckImg.alt = '';
			truckImg.setAttribute('aria-hidden', 'true');
			truckImg.width = 23;
			truckImg.height = 16;
			shippingCalcIcon.appendChild(truckImg);
		}

		var shippingCalcLabel = document.createElement('span');
		shippingCalcLabel.className = 'shipping-calc-disclosure__label';
		var shippingCalcLabelCta = document.createElement('span');
		shippingCalcLabelCta.className = 'shipping-calc-disclosure__label-cta';
		shippingCalcLabelCta.textContent = shippingEstimateStrings.label_cta;
		shippingCalcLabel.appendChild(shippingCalcLabelCta);
		shippingCalcLabel.appendChild(document.createTextNode(shippingEstimateStrings.label_suffix));

		var shippingCalcSummaryLeft = document.createElement('span');
		shippingCalcSummaryLeft.className = 'shipping-calc-disclosure__left';
		shippingCalcSummaryLeft.appendChild(shippingCalcIcon);
		shippingCalcSummaryLeft.appendChild(shippingCalcLabel);

		var shippingCalcChevron = document.createElement('span');
		shippingCalcChevron.className = 'shipping-calc-disclosure__chevron';
		shippingCalcChevron.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" aria-hidden="true">' +
			'<path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
			'</svg>';

		var shippingCalcSummaryTop = document.createElement('div');
		shippingCalcSummaryTop.className = 'shipping-calc-disclosure__summary-top';
		shippingCalcSummaryTop.appendChild(shippingCalcSummaryLeft);
		shippingCalcSummaryTop.appendChild(shippingCalcChevron);

		var shippingCalcSummary = document.createElement('summary');
		shippingCalcSummary.className = 'shipping-calc-disclosure__summary';
		shippingCalcSummary.appendChild(shippingCalcSummaryTop);

		var pdpFreeCfg = loadPdpFreeShippingConfig();
		if (pdpFreeCfg) {
			var pdpFreeRow = document.createElement('p');
			pdpFreeRow.className = 'shipping-calc-disclosure__pdp-free-shipping';
			pdpFreeRow.appendChild(document.createTextNode(pdpFreeCfg.prefix + (pdpFreeCfg.amount ? ' ' : '')));
			if (pdpFreeCfg.amount) {
				var pdpAmountStrong = document.createElement('strong');
				pdpAmountStrong.textContent = pdpFreeCfg.amount;
				pdpFreeRow.appendChild(pdpAmountStrong);
			}
			pdpFreeRow.addEventListener('click', function (e) {
				e.stopPropagation();
			});
			shippingCalcSummary.appendChild(pdpFreeRow);
		}

		var shippingCalcBody = document.createElement('div');
		shippingCalcBody.className = 'shipping-calc-disclosure__content';

		var shippingCalcDetails = document.createElement('details');
		shippingCalcDetails.className = 'shipping-calc-disclosure';
		shippingCalcDetails.appendChild(shippingCalcSummary);
		shippingCalcDetails.appendChild(shippingCalcBody);

		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.type = 'button';
		shippingCalcButton.innerText = shippingEstimateStrings.calculate;
		shippingCalcButton.className = 'button shippingCalcButton shipping-calc-disclosure__submit';
		shippingCalcButton.onclick=function(){
			if(!productSelect.value.length){ return false }
			normalizeCepInput(shippingZip);
			if(shippingZip.value != ''){
				shippingCalcButton.innerText = shippingEstimateStrings.calculating;
				shippingCalcButton.className = 'button shippingCalcButton shipping-calc-disclosure__submit disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));

			getRates(parseInt(productSelect.value));
			return false;
		};

		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingCalcDetails);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingZip.className = 'shipping-calc-disclosure__input';
		var shippingCalcRow = document.createElement('div');
		shippingCalcRow.className = 'shipping-calc-disclosure__row';
		shippingCalcRow.appendChild(shippingZip);
		shippingCalcRow.appendChild(shippingCalcButton);
		shippingCalcBody.appendChild(shippingCalcRow);
		shippingCalcBody.appendChild(shippingCalcUnknownZip);
		shippingCalcBody.appendChild(shippingMessage);

		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);

	};

	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }

		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');

		var quantity = productQuantity ? parseInt(productQuantity.value):1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};

		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* we have JSON */
			//console.log(json);
			/* Change the cookie value back to what it was */

			if (!currentProvince) {
				buscarEstadoPorCEP(shippingZip.value);
				
				if (!currentProvince) {
					shippingMessage.innerHTML = shippingEstimateStrings.invalid_cep_html;
					document.querySelector('.shippingCalcButton').innerText = shippingEstimateStrings.calculate;
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton shipping-calc-disclosure__submit';
					resetCartCookie();
					return;
				}
			}

			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]':shippingCountry.value,
				'shipping_address[province]':currentProvince,
				'shipping_address[zip]':cepDigitsOnly(shippingZip.value)
			})).then(function(response) {
				return response.json();
			}).then(function(result) {
				if(result.shipping_rates && result.shipping_rates.length){
					let messageHtml = '<ul class="shipping-calc-disclosure__rates">'
					for (let i = 0; i < result.shipping_rates.length; i++) {
						const element = result.shipping_rates[i];
						let deliveryInfo = '';
						
						if (element.name === 'Local Delivery' || element.code === 'Local Delivery') {
							deliveryInfo = element.description ? `<span class="shipping-calc-disclosure__rates-days">${element.description}</span>` : '';
						} else if (element.delivery_days && Array.isArray(element.delivery_days) && element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								deliveryInfo = '<span class="shipping-calc-disclosure__rates-days">' + shippingEstimateStrings.one_business_day + '</span>';
							} else {
								deliveryInfo = '<span class="shipping-calc-disclosure__rates-days">' + formatBusinessDays(shippingEstimateStrings.business_days, element.delivery_days[0]) + '</span>';
							}
						}
						var rateName = element.name === 'Local Delivery' ? shippingEstimateStrings.local_delivery : element.name;
						var priceFormatted = element.price.replace('.', ',');
						messageHtml += `
						<li class="shipping-calc-disclosure__rates-item">
							${rateName} ${shippingEstimateStrings.rate_for} <b>${shippingEstimateStrings.price_currency} ${priceFormatted}</b>
							${deliveryInfo ? '<br>' + deliveryInfo : ''}
						</li>
						`;
					}
					messageHtml += '</ul>';
					shippingMessage.innerHTML = messageHtml;
					document.querySelector('.shippingCalcButton').innerText = shippingEstimateStrings.calculate;
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton shipping-calc-disclosure__submit';
				}
				resetCartCookie()
			}).catch(function() {
				resetCartCookie();
				shippingMessage.innerHTML = '';
				document.querySelector('.shippingCalcButton').innerText = shippingEstimateStrings.calculate;
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton shipping-calc-disclosure__submit';
			})
		}).catch(function(err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});

	};

	initFields();
})()
